import { Link } from '@remix-run/react'
import { CheckCircle } from 'lucide-react'
import { ClientOnly } from 'remix-utils/client-only'
import Countdown from '../countdown'
import { Button } from '../ui/button'
import EnrollCTA from './enroll-now-cta'
import StartingFrom from './starting-from'

export default function HeroMock() {
	const features = [
		'Attend online tests from the comfort of your home',
		'Easily scan OMR sheets using your phone',
		'Receive a detailed report within 30 minutes of submission',
		'Compete with top aspirants nationwide, receive a rank for each test',
		'Get detailed solutions to improve your performance',
	]

	return (
		<>
			<div className="relative isolate px-6 pt-4 lg:px-8">
				<div
					aria-hidden="true"
					className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
				>
					<div
						style={{
							clipPath:
								'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
						}}
						className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#e38c34] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
					/>
				</div>
				<div className="mx-auto max-w-7xl pb-2 sm:pb-2 lg:flex lg:px-8 lg:py-4">
					<div className="mx-auto max-w-2xl lg:pt-8">
						<div className="sm:mb-8 sm:flex sm:justify-center">
							<div className="relative px-1 py-1 text-lg ring-gray-900 hover:ring-gray-900/20 dark:ring-gray-100 sm:rounded-full sm:px-3 sm:text-sm/6 sm:ring-1">
								India's first OMR sheet based online mock test.{' '}
								<span className="font-semibold text-orange-600">
									<span aria-hidden="true" className="absolute inset-0" />
									Powered by marky.in
								</span>
							</div>
						</div>
						<h1 className="sm:ext-4xl mt-10 text-left text-4xl font-bold tracking-tight text-orange-500 sm:text-center sm:text-6xl">
							Marky Testing Academy
						</h1>
						<h2 className="mt-2 text-left text-3xl font-bold tracking-tight text-orange-900 dark:text-orange-300 sm:text-center sm:text-5xl">
							All India NEET Mock Test 2025
						</h2>
						<p className="mt-6 text-left text-lg leading-8 sm:text-center">
							Real OMR Sheet Testing. For Superior Exam Readiness and
							Competitive Advantage!
						</p>

						<div className="flex items-center justify-center">
							<div className="max-w-lg rounded-lg bg-background p-8">
								<h1 className="mb-6 text-center text-2xl font-bold">
									All India NEET Mock Test links are now live!
								</h1>
								<div className="space-y-8">
									<Link to="../signup" className="block w-full">
										<Button
											className="w-full bg-orange-500 text-base font-bold text-white hover:bg-orange-700"
											variant={'default'}
										>
											Enroll Now for free
										</Button>
									</Link>
								</div>
							</div>
						</div>

						<div className="mt-6 flex flex-col justify-between sm:flex-row">
							<div className="mb-6 flex w-full flex-col items-center justify-center">
								<h2 className="my-6 text-center text-2xl font-bold text-orange-500">
									Get ready
								</h2>
								<div className="flex h-[115px] flex-col items-center rounded-lg border border-orange-200 p-6 shadow-md">
									<div className="text-6xl font-bold text-orange-500">100+</div>
								</div>
								<div className="p-4 text-lg font-medium text-foreground">
									Free Mock Tests on OMR sheet, tests added daily
								</div>
							</div>
						</div>

						<div className="flex items-center justify-center">
							<div className="rounded-lg border border-orange-200 bg-white p-6 shadow-md">
								<ul className="space-y-4">
									{features.map((feature, index) => (
										<li key={index} className="flex items-center space-x-3">
											<CheckCircle
												className="flex-shrink-0 text-orange-500 sm:inline-block"
												size={24}
											/>
											<span className="text-lg text-gray-700">{feature}</span>
										</li>
									))}
								</ul>
							</div>
						</div>

						<EnrollCTA />
					</div>
				</div>
				<div
					aria-hidden="true"
					className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]"
				>
					<div
						style={{
							clipPath:
								'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
						}}
						className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#ece830] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]"
					/>
				</div>
			</div>
			<div className="relative isolate overflow-hidden bg-background">
				<svg
					aria-hidden="true"
					className="absolute inset-0 -z-10 hidden h-full w-full stroke-gray-200 [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)] sm:block"
				>
					<defs>
						<pattern
							x="50%"
							y={-1}
							id="0787a7c5-978c-4f66-83c7-11c213f99cb7"
							width={200}
							height={200}
							patternUnits="userSpaceOnUse"
						>
							<path d="M.5 200V.5H200" fill="none" />
						</pattern>
					</defs>
					<rect
						fill="url(#0787a7c5-978c-4f66-83c7-11c213f99cb7)"
						width="100%"
						height="100%"
						strokeWidth={0}
					/>
				</svg>
			</div>
		</>
	)
}
